import PropTypes from 'prop-types';

export const disciplineShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  localizationValue: PropTypes.string.isRequired,
});

export const kununuShape = PropTypes.shape({
  companyProfileUrl: PropTypes.string,
  ratingAverage: PropTypes.number,
  ratingCount: PropTypes.number,
});

const companyShape = PropTypes.shape({
  logo: PropTypes.shape({
    url: PropTypes.string.isRequired,
  }),
  name: PropTypes.string,
  kununuData: kununuShape,
  links: PropTypes.shape({
    public: PropTypes.string.isRequired,
  }),
  userContext: PropTypes.shape({
    followState: PropTypes.shape({
      isFollowing: PropTypes.bool,
    }),
  }),
});

export const companyInfoShape = PropTypes.shape({
  companyNameOverride: PropTypes.string.isRequired,
  company: companyShape,
});

export const featuresShape = PropTypes.shape({
  upsellUrl: PropTypes.string,
});

export const salaryShape = PropTypes.shape({
  __typename: PropTypes.string,
  currency: PropTypes.string,
  amount: PropTypes.number,
  minimum: PropTypes.number,
  maximum: PropTypes.number,
  median: PropTypes.number,
});

const emailApplicationShape = PropTypes.shape({
  __typename: PropTypes.string,
  applyEmail: PropTypes.string.isRequired,
});

const urlApplicationShape = PropTypes.shape({
  __typename: PropTypes.string,
  applyUrl: PropTypes.string.isRequired,
});

const messengerApplicationShape = PropTypes.shape({
  __typename: PropTypes.string,
  contactUserId: PropTypes.string.isRequired,
});

const xingApplicationShape = PropTypes.shape({
  __typename: PropTypes.string,
});

export const applicationShape = PropTypes.oneOfType([
  emailApplicationShape,
  urlApplicationShape,
  messengerApplicationShape,
  xingApplicationShape,
]);

export const userInteractionsShape = PropTypes.shape({
  bookmark: PropTypes.shape({
    state: PropTypes.oneOf(['NOT_BOOKMARKED', 'SAVED', 'APPLIED', 'INTERVIEW_SET']).isRequired,
  }),
});

export const HTMLDescriptionShape = PropTypes.shape({
  __typename: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
});

export const ExternalURLDescriptionShape = PropTypes.shape({
  __typename: PropTypes.string.isRequired,
  proxyUrl: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
});

export const PdfDescriptionShape = PropTypes.shape({
  __typename: PropTypes.string.isRequired,
  pdfUrl: PropTypes.string.isRequired,
  previewImage: PropTypes.shape({
    url: PropTypes.string.isRequired,
  }).isRequired,
});

export const descriptionShape = PropTypes.oneOfType([
  HTMLDescriptionShape,
  ExternalURLDescriptionShape,
  PdfDescriptionShape,
]);

export const jobShape = PropTypes.shape({
  slug: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  employmentType: PropTypes.shape({
    type: PropTypes.string,
  }),
  date: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  salary: salaryShape,
  application: applicationShape,
  userInteractions: userInteractionsShape,
  features: featuresShape,
  projob: PropTypes.bool,
  prioritized: PropTypes.bool,
  industry: PropTypes.shape({
    title: PropTypes.string.isRequired,
  }),
  discipline: disciplineShape,
  banner: PropTypes.shape({
    url: PropTypes.string.isRequired,
  }),
  description: descriptionShape,
  companyInfo: companyInfoShape,
  location: PropTypes.shape({
    city: PropTypes.string,
  }),
});

export const similarJobsShape = PropTypes.shape({
  loading: PropTypes.bool,
  data: PropTypes.oneOfType([PropTypes.arrayOf(jobShape), PropTypes.arrayOf(PropTypes.object)]),
});
